import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

import { getUserProfile, useUserApi } from '@/api'
import { UserInputType, UserType } from '@/types'
import { useToast } from '@/ui'

export const useProfileStore = defineStore('profile', () => {
  const { toast } = useToast()

  const profile = ref<UserType | null>(null)
  const isSavingProfile = ref(false)

  const { saveMyProfile } = useUserApi()
  const { responseData, execute, isFetching: isFetchingProfile } = getUserProfile()

  if (!profile.value) {
    execute()
  }

  watch(responseData, newVal => {
    if (newVal) {
      profile.value = newVal
    }
  })

  function onSaveProfile(values: UserInputType) {
    isSavingProfile.value = true
    const { isFinished, responseData, error } = saveMyProfile(values)

    watch(isFinished, newVal => {
      if (newVal && !error?.value && responseData.value) {
        profile.value = responseData.value

        toast({
          title: 'Success',
          description: 'Profile updated successfully',
        })
      }

      isSavingProfile.value = false
    })
  }

  return {
    profile,
    isFetchingProfile,
    isSavingProfile,

    onSaveProfile,
  }
})
